var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.clipped)?_c('el-tooltip',{attrs:{"content":_vm.text,"placement":"top","effect":"dark","open-delay":200}},[_c('div',{ref:"box",staticClass:"clamp-cell",style:(_vm.clampStyle)},[_vm._v(_vm._s(_vm.text))])]):_c('div',{ref:"box",staticClass:"clamp-cell",style:(_vm.clampStyle)},[_vm._v(_vm._s(_vm.text))])
}
var staticRenderFns = []

export { render, staticRenderFns }